export const BROWSER_STORE_KEY = '__GATSBY_SOURCE_PRISMIC__'

export const IMAGE_FIELD_KEYS = [
  'alt',
  'copyright',
  'dimensions',
  'url',
] as const

export const API_PAGE_SIZE = 100

export const UUID_NAMESPACE = `638f7a53-c567-4eca-8fc1-b23efb1cfb2b`

export const PLACEHOLDER_NODE_TYPE_SUFFIX = '__PLACEHOLDER'
